// Standard ISO language codes supported by ChoiceDekho (matching backend catalog)
export const LANGUAGE_CODES = [
  "en", "es", "hi", "fr", "de", "zh", "ja", "pt", "ar", "ru",
  "it", "ko", "nl", "id", "tr", "pl", "sv", "th", "vi", "ur",
  "ta", "te", "mr", "bn", "gu", "kn", "ml", "ne", "fa", "he",
  "uk", "ro", "el", "hu", "cs", "sk", "no", "fi", "da",
  "fil", "ms", "kk", "uz", "az", "ka", "hy", "my", "km", "sw",
  "af", "so", "qu", "lv", "et", "sr", "hr", "ca", "tl", "ps", "ku"
];

// Common legacy full name to ISO code mappings
const LEGACY_NAME_TO_CODE = {
  english: "en",
  spanish: "es",
  espanol: "es",
  hindi: "hi",
  french: "fr",
  german: "de",
  chinese: "zh",
  japanese: "ja",
  portuguese: "pt",
  arabic: "ar",
  russian: "ru",
  italian: "it",
  korean: "ko",
  dutch: "nl",
  indonesian: "id",
  turkish: "tr",
  polish: "pl",
  swedish: "sv",
  thai: "th",
  vietnamese: "vi",
  urdu: "ur",
  tamil: "ta",
  telugu: "te",
  marathi: "mr",
  bengali: "bn",
  gujarati: "gu",
  kannada: "kn",
  malayalam: "ml",
  nepali: "ne",
  persian: "fa",
  hebrew: "he",
  ukrainian: "uk",
  romanian: "ro",
  greek: "el",
  hungarian: "hu",
  magyar: "hu",
  czech: "cs",
  slovak: "sk",
  norwegian: "no",
  finnish: "fi",
  danish: "da",
  filipino: "fil",
  tagalog: "tl",
  malay: "ms",
  kazakh: "kk",
  uzbek: "uz",
  azeri: "az",
  georgian: "ka",
  armenian: "hy",
  burmese: "my",
  khmer: "km",
  swahili: "sw",
  afrikaans: "af",
  somali: "so",
  quechua: "qu",
  latvian: "lv",
  estonian: "et",
  serbian: "sr",
  croatian: "hr",
  catalan: "ca",
  pashto: "ps",
  kurdish: "ku"
};

// Deduplicate codes
const uniqueCodes = Array.from(new Set(LANGUAGE_CODES));

let displayNamesFormatter = null;
try {
  displayNamesFormatter = new Intl.DisplayNames(["en"], { type: "language" });
} catch (e) {
  // Fallback if Intl.DisplayNames is not supported in environment
}

/**
 * Get human-readable language name for a given code (e.g. 'es' -> 'Spanish')
 */
export const getLanguageName = (code) => {
  if (!code) return "";
  const normalized = code.trim().toLowerCase();
  try {
    if (displayNamesFormatter) {
      const name = displayNamesFormatter.of(normalized);
      if (name && name !== normalized) return name;
    }
  } catch (e) {
    // ignore
  }
  return normalized;
};

/**
 * Formatted options list for select dropdowns
 * returns [{ _id: "en", name: "English (en)" }, ...]
 */
export const LANGUAGE_OPTIONS = uniqueCodes.map((code) => {
  const name = getLanguageName(code);
  const label = name && name.toLowerCase() !== code.toLowerCase()
    ? `${name} (${code})`
    : code.toUpperCase();
  return {
    _id: code,
    code: code,
    name: label,
  };
}).sort((a, b) => a.name.localeCompare(b.name));

/**
 * Normalize incoming language value (code or legacy name) to standard code
 */
export const normalizeLanguageCode = (val) => {
  if (!val) return "en";
  const str = String(val).trim().toLowerCase();
  if (LEGACY_NAME_TO_CODE[str]) return LEGACY_NAME_TO_CODE[str];
  if (uniqueCodes.includes(str)) return str;
  return str;
};
